



















































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import BaseSelectResearchCenter from "@/components/base/baseSelectResearchCenter/baseSelectResearchCenterReport.vue";
import BaseSelectPerson from "@/components/base/baseSelectPerson/baseSelectPerson.vue";
import { Component, Vue, Watch } from "vue-property-decorator";
import { ProposalState } from '@/enums/ProposalState';

@Component({
  components: {
    baseSelectPerson: BaseSelectPerson,
    baseSelectResearchCenter: BaseSelectResearchCenter
  }
})
export default class Reportes extends Vue {
  isLoading = false;
  proposalStates: Array<{
    title: string,
    id: number
  }> = [
    {
      title: 'Creado',
      id: ProposalState.Creado
    },
    {
      title: 'Enviada al institución proponente',
      id: ProposalState.EnviadoCI
    },
    {
      title: 'Devuelto por la institución proponente',
      id: ProposalState.DevueltoCI
    },
    {
      title: 'Aprobada por la institución proponente',
      id: ProposalState.AprobadoCI
    },
    {
      title: 'Rechazado por la institución proponente',
      id: ProposalState.RechazadoCI
    },
    {
      title: 'Enviada a FONDOCYT',
      id: ProposalState.EnviadoFC
    },
    {
      title: 'Aprobada por FONDOCYT',
      id: ProposalState.AprobadoFC
    },
    {
      title: 'Devuelto por FONDOCYT',
      id: ProposalState.DevueltoFC
    },
    {
      title: 'Rechazado por FONDOCYT',
      id: ProposalState.RechazadoFC
    },
    {
      title: 'Cerrado por FONDOCYT',
      id: ProposalState.CerradoFC
    },
  ]

  parameterId: any = {
    proyectId: null,
    researchCenterId: null,
    investigadorId: null,
    areaId: null,
    annoucementId: null,
    facultyId: null,
    areaFondocytId: null
  };

  parameter: any = {
    siglas: null,
    code:null,
    faculty:null,
    proyect: null,
    researchCenter: null,
    investigador: null,
    area: null,
    isApproved: null,
    announcement: null,
    proposalState: null,
    areaFondocy: null
  };

  setProposalState(data) {
    this.parameter.proposalState = data.id
  }

  openSolicitudDesembolsoReport() {
    var url =
      process.env.VUE_APP_BASE_URL_REPORT +
      `Report/VistaSolicitudDesembolso?ETLProyecto=${this.parameter.proyect}&ETLInstitucion=${this.parameter.researchCenter}&ETLSiglas=${this.parameter.siglas}&ETLInvestigadorPrincipal=${this.parameter.investigador}&ETLFacultad=${this.parameter.faculty}&ETLCodigo=${this.parameter.code}&ETLAreas=${encodeURIComponent(this.parameter.area)}&ETLConvocatoria=${this.parameter.announcement}`;
    window.open(url, "Reporte de solicitud de desembolso");
  }

  downloadSolicitudDesembolsoReport() {
    var url =
      process.env.VUE_APP_BASE_URL_REPORT +
      `Report/DownloadSolicitudDesembolso?ETLProyecto=${this.parameter.proyect}&ETLInstitucion=${this.parameter.researchCenter}&ETLSiglas=${this.parameter.siglas}&ETLInvestigadorPrincipal=${this.parameter.investigador}&ETLFacultad=${this.parameter.faculty}&ETLCodigo=${this.parameter.code}&ETLAreas=${encodeURIComponent(this.parameter.area)}&ETLConvocatoria=${this.parameter.announcement}`;
    window.open(url, "Reporte de solicitud de desembolso");
  }

  //

  openControlDesembolsoProyectoReport() {
    var url =
      process.env.VUE_APP_BASE_URL_REPORT +
      `Report/VistaControlDesembolsoProyecto?ETLProyecto=${this.parameter.proyect}&ETLInstitucion=${this.parameter.researchCenter}&ETLSiglas=${this.parameter.siglas}&ETLInvestigadorPrincipal=${this.parameter.investigador}&ETLFacultad=${this.parameter.faculty}&ETLCodigo=${this.parameter.code}&ETLAreas=${encodeURIComponent(this.parameter.area)}&ETLConvocatoria=${this.parameter.announcement}`;
    window.open(url, "Reporte de control de desembolso");
  }

  downloadControlDesembolsoProyectoReport() {
    var url =
      process.env.VUE_APP_BASE_URL_REPORT +
      `Report/DownloadControlDesembolsoProyecto?ETLProyecto=${this.parameter.proyect}&ETLInstitucion=${this.parameter.researchCenter}&ETLSiglas=${this.parameter.siglas}&ETLInvestigadorPrincipal=${this.parameter.investigador}&ETLFacultad=${this.parameter.faculty}&ETLCodigo=${this.parameter.code}&ETLAreas=${encodeURIComponent(this.parameter.area)}&ETLConvocatoria=${this.parameter.announcement}`;
    window.open(url, "Reporte de control de desembolso");
  }

  // update ^

  openReporteProyectoAprobado() {
    var url =
      process.env.VUE_APP_BASE_URL_REPORT +
      `Report/VistaProyectoAprobado?ETLProyecto=${this.parameter.proyect}&ETLInstitucion=${this.parameter.researchCenter}&ETLSiglas=${this.parameter.siglas}&ETLInvestigadorPrincipal=${this.parameter.investigador}&ETLFacultad=${this.parameter.faculty}&ETLCodigo=${this.parameter.code}&ETLAreas=${encodeURIComponent(this.parameter.area)}&ETLConvocatoria=${this.parameter.announcement}`;
    window.open(url, "Reporte de proyectos aprobados");
  }

  downloadReporteProyectoAprobado() {
    var url =
      process.env.VUE_APP_BASE_URL_REPORT +
      `Report/DownloadProyectoAprobado?ETLProyecto=${this.parameter.proyect}&ETLInstitucion=${this.parameter.researchCenter}&ETLSiglas=${this.parameter.siglas}&ETLInvestigadorPrincipal=${this.parameter.investigador}&ETLFacultad=${this.parameter.faculty}&ETLCodigo=${this.parameter.code}&ETLAreas=${encodeURIComponent(this.parameter.area)}&ETLConvocatoria=${this.parameter.announcement}`;
    window.open(url, "Reporte de proyectos aprobados");
  }

  // update ^

  openReporteProyectoAprobado1() {
    var url =
      process.env.VUE_APP_BASE_URL_REPORT +
      `Report/VistaProyectoAprobado1?ETLProyecto=${this.parameter.proyect}&ETLInstitucion=${this.parameter.researchCenter}&ETLSiglas=${this.parameter.siglas}&ETLInvestigadorPrincipal=${this.parameter.investigador}&ETLFacultad=${this.parameter.faculty}&ETLCodigo=${this.parameter.code}&ETLAreas=${encodeURIComponent(this.parameter.area)}&ETLConvocatoria=${this.parameter.announcement}&ETLAprobado=${this.parameter.isApproved}`;
    window.open(url, "Reporte de proyectos vigentes");
  }

  downloadReporteProyectoAprobado1() {
    var url =
      process.env.VUE_APP_BASE_URL_REPORT +
      `Report/DownloadProyectoAprobado1?ETLProyecto=${this.parameter.proyect}&ETLInstitucion=${this.parameter.researchCenter}&ETLSiglas=${this.parameter.siglas}&ETLInvestigadorPrincipal=${this.parameter.investigador}&ETLFacultad=${this.parameter.faculty}&ETLCodigo=${this.parameter.code}&ETLAreas=${encodeURIComponent(this.parameter.area)}&ETLConvocatoria=${this.parameter.announcement}&ETLAprobado=${this.parameter.isApproved}`;
    window.open(url, "Reporte de proyectos vigentes");
  }

  // update ^

  openReporteProyectoVigente() {
    var url =
      process.env.VUE_APP_BASE_URL_REPORT +
      `Report/VistaProyectoVigente?ETLProyecto=${this.parameter.proyect}&ETLInstitucion=${this.parameter.researchCenter}&ETLSiglas=${this.parameter.siglas}&ETLInvestigadorPrincipal=${this.parameter.investigador}&ETLFacultad=${this.parameter.faculty}&ETLCodigo=${this.parameter.code}&ETLAreas=${encodeURIComponent(this.parameter.area)}&ETLConvocatoria=${this.parameter.announcement}`;
    window.open(url, "Reporte de proyectos vigentes");
  }

  downloadReporteProyectoVigente() {
    var url =
      process.env.VUE_APP_BASE_URL_REPORT +
      `Report/DownloadProyectoVigente?ETLProyecto=${this.parameter.proyect}&ETLInstitucion=${this.parameter.researchCenter}&ETLSiglas=${this.parameter.siglas}&ETLInvestigadorPrincipal=${this.parameter.investigador}&ETLFacultad=${this.parameter.faculty}&ETLCodigo=${this.parameter.code}&ETLAreas=${encodeURIComponent(this.parameter.area)}&ETLConvocatoria=${this.parameter.announcement}`;
    window.open(url, "Reporte de proyectos vigentes");
  }
  
  // update ^

  openReporteProyectoVigente1() {
    var url =
      process.env.VUE_APP_BASE_URL_REPORT +
      `Report/VistaProyectoVigente1?ETLProyecto=${this.parameter.proyect}&ETLInstitucion=${this.parameter.researchCenter}&ETLSiglas=${this.parameter.siglas}&ETLInvestigadorPrincipal=${this.parameter.investigador}&ETLFacultad=${this.parameter.faculty}&ETLCodigo=${this.parameter.code}&ETLAreas=${encodeURIComponent(this.parameter.area)}&ETLConvocatoria=${this.parameter.announcement}&ETLEstado_IES=${this.parameter.proposalState}`;
    window.open(url, "Reporte de proyectos vigentes 1.1");
  }
  
  downloadReporteProyectoVigente1() {
    var url =
      process.env.VUE_APP_BASE_URL_REPORT +
      `Report/DownloadProyectoVigente1?ETLProyecto=${this.parameter.proyect}&ETLInstitucion=${this.parameter.researchCenter}&ETLSiglas=${this.parameter.siglas}&ETLInvestigadorPrincipal=${this.parameter.investigador}&ETLFacultad=${this.parameter.faculty}&ETLCodigo=${this.parameter.code}&ETLAreas=${encodeURIComponent(this.parameter.area)}&ETLConvocatoria=${this.parameter.announcement}&ETLEstado_IES=${this.parameter.proposalState}`;
    window.open(url, "Reporte de proyectos vigentes 1");
  }

  // update ^

  openReporteProyectoVigente2() {
    var url =
      process.env.VUE_APP_BASE_URL_REPORT +
      `Report/VistaProyectoVigente2?ETLProyecto=${this.parameter.proyect}&ETLInstitucion=${this.parameter.researchCenter}&ETLSiglas=${this.parameter.siglas}&ETLInvestigadorPrincipal=${this.parameter.investigador}&ETLFacultad=${this.parameter.faculty}&ETLCodigo=${this.parameter.code}&ETLAreas=${encodeURIComponent(this.parameter.area)}&ETLConvocatoria=${this.parameter.announcement}`;
    window.open(url, "Reporte de proyectos vigentes 2");
  }

  downloadReporteProyectoVigente2() {
    var url =
      process.env.VUE_APP_BASE_URL_REPORT +
      `Report/DownloadProyectoVigente2?ETLProyecto=${this.parameter.proyect}&ETLInstitucion=${this.parameter.researchCenter}&ETLSiglas=${this.parameter.siglas}&ETLInvestigadorPrincipal=${this.parameter.investigador}&ETLFacultad=${this.parameter.faculty}&ETLCodigo=${this.parameter.code}&ETLAreas=${encodeURIComponent(this.parameter.area)}&ETLConvocatoria=${this.parameter.announcement}`;
    window.open(url, "Reporte de proyectos vigentes 2");
  }

  // update ^

  openReporteProyectoVigente3() {
    var url =
      process.env.VUE_APP_BASE_URL_REPORT +
      `Report/VistaProyectoVigente3?ETLProyecto=${this.parameter.proyect}&ETLInstitucion=${this.parameter.researchCenter}&ETLSiglas=${this.parameter.siglas}&ETLInvestigadorPrincipal=${this.parameter.investigador}&ETLFacultad=${this.parameter.faculty}&ETLCodigo=${this.parameter.code}&ETLAreas=${encodeURIComponent(this.parameter.area)}&ETLConvocatoria=${this.parameter.announcement}`;
    window.open(url, "Reporte de proyectos vigentes 3");
  }

  downloadReporteProyectoVigente3() {
    var url =
      process.env.VUE_APP_BASE_URL_REPORT +
      `Report/DownloadProyectoVigente3?ETLProyecto=${this.parameter.proyect}&ETLInstitucion=${this.parameter.researchCenter}&ETLSiglas=${this.parameter.siglas}&ETLInvestigadorPrincipal=${this.parameter.investigador}&ETLFacultad=${this.parameter.faculty}&ETLCodigo=${this.parameter.code}&ETLAreas=${encodeURIComponent(this.parameter.area)}&ETLConvocatoria=${this.parameter.announcement}`;
    window.open(url, "Reporte de proyectos vigentes 3");
  }

  // update ^

  openReporteCalendarioDesembolsos() {
    var url =
      process.env.VUE_APP_BASE_URL_REPORT +
      `Report/VistaCalendarioDeDesembolsos?ETLProyecto=${this.parameter.proyect}&ETLInstitucion=${this.parameter.researchCenter}&ETLSiglas=${this.parameter.siglas}&ETLInvestigadorPrincipal=${this.parameter.investigador}&ETLFacultad=${this.parameter.faculty}&ETLCodigo=${this.parameter.code}&ETLAreas=${encodeURIComponent(this.parameter.area)}&ETLConvocatoria=${this.parameter.announcement}`;
    window.open(url, "Reporte de proyectos vigentes");
  }

  downloadReporteCalendarioDesembolsos() {
    var url =
      process.env.VUE_APP_BASE_URL_REPORT +
      `Report/DownloadCalendarioDeDesembolsos?ETLProyecto=${this.parameter.proyect}&ETLInstitucion=${this.parameter.researchCenter}&ETLSiglas=${this.parameter.siglas}&ETLInvestigadorPrincipal=${this.parameter.investigador}&ETLFacultad=${this.parameter.faculty}&ETLCodigo=${this.parameter.code}&ETLAreas=${encodeURIComponent(this.parameter.area)}&ETLConvocatoria=${this.parameter.announcement}`;
    window.open(url, "Reporte de proyectos vigentes");
  }

  // update ^

  openReporteControlDeBalancePorProyecto() {
    var url =
      process.env.VUE_APP_BASE_URL_REPORT +
      `Report/VistaControlDeBalancePorProyecto?ETLProyecto=${this.parameter.proyect}&ETLInstitucion=${this.parameter.researchCenter}&ETLSiglas=${this.parameter.siglas}&ETLInvestigadorPrincipal=${this.parameter.investigador}&ETLFacultad=${this.parameter.faculty}&ETLCodigo=${this.parameter.code}&ETLAreas=${encodeURIComponent(this.parameter.area)}&ETLConvocatoria=${this.parameter.announcement}`;
    window.open(url, "Reporte de control de balance desembolso");
  }

  downloadReporteControlDeBalancePorProyecto() {
    var url =
      process.env.VUE_APP_BASE_URL_REPORT +
      `Report/DownloadControlDeBalancePorProyecto?ETLProyecto=${this.parameter.proyect}&ETLInstitucion=${this.parameter.researchCenter}&ETLSiglas=${this.parameter.siglas}&ETLInvestigadorPrincipal=${this.parameter.investigador}&ETLFacultad=${this.parameter.faculty}&ETLCodigo=${this.parameter.code}&ETLAreas=${encodeURIComponent(this.parameter.area)}&ETLConvocatoria=${this.parameter.announcement}`;
    window.open(url, "Reporte de control de balance desembolso");
  }

  // update ^ 

  openReporteProyectosPorInstitucion() {
    var url =
      process.env.VUE_APP_BASE_URL_REPORT +
      `Report/VistaProyectosPorInstitucion?ETLProyecto=${this.parameter.proyect}&ETLInstitucion=${this.parameter.researchCenter}&ETLSiglas=${this.parameter.siglas}&ETLInvestigadorPrincipal=${this.parameter.investigador}&ETLFacultad=${this.parameter.faculty}&ETLCodigo=${this.parameter.code}&ETLAreas=${encodeURIComponent(this.parameter.area)}&ETLConvocatoria=${this.parameter.announcement}`;
    window.open(url, "Reporte de proyectos por institución");
  }

  downloadReporteProyectosPorInstitucion() {
    var url =
      process.env.VUE_APP_BASE_URL_REPORT +
      `Report/DownloadProyectosPorInstitucion?ETLProyecto=${this.parameter.proyect}&ETLInstitucion=${this.parameter.researchCenter}&ETLSiglas=${this.parameter.siglas}&ETLInvestigadorPrincipal=${this.parameter.investigador}&ETLFacultad=${this.parameter.faculty}&ETLCodigo=${this.parameter.code}&ETLAreas=${encodeURIComponent(this.parameter.area)}&ETLConvocatoria=${this.parameter.announcement}`;
    window.open(url, "Reporte de proyectos por institución");
  }

  // update ^

  openReporteBitacoraDeInformeDeAvance() {
    var url =
      process.env.VUE_APP_BASE_URL_REPORT +
      `Report/VistaBitacoraDeInformeDeAvance?ETLProyecto=${this.parameter.proyect}&ETLInstitucion=${this.parameter.researchCenter}&ETLSiglas=${this.parameter.siglas}&ETLInvestigadorPrincipal=${this.parameter.investigador}&ETLFacultad=${this.parameter.faculty}&ETLCodigo=${this.parameter.code}&ETLAreas=${encodeURIComponent(this.parameter.area)}&ETLConvocatoria=${this.parameter.announcement}`;
    window.open(url, "Reporte bitacora de informe de avance");
  }

  downloadReporteBitacoraDeInformeDeAvance() {
    var url =
      process.env.VUE_APP_BASE_URL_REPORT +
      `Report/DownloadBitacoraDeInformeDeAvance?ETLProyecto=${this.parameter.proyect}&ETLInstitucion=${this.parameter.researchCenter}&ETLSiglas=${this.parameter.siglas}&ETLInvestigadorPrincipal=${this.parameter.investigador}&ETLFacultad=${this.parameter.faculty}&ETLCodigo=${this.parameter.code}&ETLAreas=${encodeURIComponent(this.parameter.area)}&ETLConvocatoria=${this.parameter.announcement}`;
    window.open(url, "Reporte bitacora de informe de avance");
  }

  // update ^
  
  openReporteBitacoraDeInformeDeAvance1() {
    var url =
      process.env.VUE_APP_BASE_URL_REPORT +
      `Report/VistaBitacoraDeInformeDeAvance1?ETLProyecto=${this.parameter.proyect}&ETLInstitucion=${this.parameter.researchCenter}&ETLSiglas=${this.parameter.siglas}&ETLInvestigadorPrincipal=${this.parameter.investigador}&ETLFacultad=${this.parameter.faculty}&ETLCodigo=${this.parameter.code}&ETLAreas=${encodeURIComponent(this.parameter.area)}&ETLConvocatoria=${this.parameter.announcement}`;
    window.open(url, "Reporte bitacora de informe de avance");
  }

  downloadReporteBitacoraDeInformeDeAvance1() {
    var url =
      process.env.VUE_APP_BASE_URL_REPORT +
      `Report/DownloadBitacoraDeInformeDeAvance1?ETLProyecto=${this.parameter.proyect}&ETLInstitucion=${this.parameter.researchCenter}&ETLSiglas=${this.parameter.siglas}&ETLInvestigadorPrincipal=${this.parameter.investigador}&ETLFacultad=${this.parameter.faculty}&ETLCodigo=${this.parameter.code}&ETLAreas=${encodeURIComponent(this.parameter.area)}&ETLConvocatoria=${this.parameter.announcement}`;
    window.open(url, "Reporte bitacora de informe de avance");
  }

  // update ^

  openReporteVistaProyectoAprobado13() {
    var url =
      process.env.VUE_APP_BASE_URL_REPORT + `Report/VistaProyectoAprobado13?ETLProyecto=${this.parameter.proyect}&ETLInstitucion=${this.parameter.researchCenter}&ETLSiglas=${this.parameter.siglas}&ETLInvestigadorPrincipal=${this.parameter.investigador}&ETLFacultad=${this.parameter.faculty}&ETLCodigo=${this.parameter.code}&ETLAreas=${encodeURIComponent(this.parameter.area)}&ETLConvocatoria=${this.parameter.announcement}`;
    window.open(url, "Reporte proyecto aprobado");
  }

  downloadReporteVistaProyectoAprobado13() {
    var url =
      process.env.VUE_APP_BASE_URL_REPORT + `Report/DownloadProyectoAprobado13?ETLProyecto=${this.parameter.proyect}&ETLInstitucion=${this.parameter.researchCenter}&ETLSiglas=${this.parameter.siglas}&ETLInvestigadorPrincipal=${this.parameter.investigador}&ETLFacultad=${this.parameter.faculty}&ETLCodigo=${this.parameter.code}&ETLAreas=${encodeURIComponent(this.parameter.area)}&ETLConvocatoria=${this.parameter.announcement}`;
    window.open(url, "Reporte proyecto aprobado");
  }

  // update ^

  openReporteProyectosEnIES() {
    var url =
      process.env.VUE_APP_BASE_URL_REPORT +
      `Report/ProyectosEnIES?ETLProyecto=${this.parameter.proyect}&ETLInstitucion=${this.parameter.researchCenter}&ETLSiglas=${this.parameter.siglas}&ETLInvestigadorPrincipal=${this.parameter.investigador}&ETLFacultad=${this.parameter.faculty}&ETLCodigo=${this.parameter.code}&ETLAreas=${encodeURIComponent(this.parameter.area)}&ETLConvocatoria=${this.parameter.announcement}&ETLEstado_IES=${this.parameter.proposalState}`;
    window.open(url, "Reporte Proyectos en IES");
  }

  downloadReporteProyectosEnIES() {
    var url =
      process.env.VUE_APP_BASE_URL_REPORT +
      `Report/DownloadProyectosEnIES?ETLProyecto=${this.parameter.proyect}&ETLInstitucion=${this.parameter.researchCenter}&ETLSiglas=${this.parameter.siglas}&ETLInvestigadorPrincipal=${this.parameter.investigador}&ETLFacultad=${this.parameter.faculty}&ETLCodigo=${this.parameter.code}&ETLAreas=${encodeURIComponent(this.parameter.area)}&ETLConvocatoria=${this.parameter.announcement}&ETLEstado_IES=${this.parameter.proposalState}`;
    window.open(url, "Reporte Proyectos en IES");
  }
}
